'use client';

import LinkButton from '@/components/atoms/LinkButton';
import { SvgIcon } from '@/components/SvgIcon';

import iconArrowUpRightSrc from '~/icons/arrow-up-right.svg';

export type SliceHeaderCtaProps = {
  href: string;
};

export function SliceHeaderCta({ href }: SliceHeaderCtaProps) {
  return (
    <div className='shrink-0 px-3'>
      <LinkButton
        href={href}
        noStyles
        aria-label='Open section link'
        classNames={{
          root: 'inline-flex size-10 items-center justify-center rounded-full bg-gray-dark-100 opacity-50 transition-opacity hover:opacity-70 headerLg:size-auto headerLg:p-2.5',
          inner: 'flex items-center justify-center',
        }}
      >
        <SvgIcon
          src={iconArrowUpRightSrc}
          className='size-6 text-gray-dark-950'
          aria-hidden
        />
      </LinkButton>
    </div>
  );
}
